// store/caf.js
import axios from 'axios'

export default {
  namespaced: true,
  state: {
    info: null,
    deleghe: [],        // array delle deleghe
    delega: null,       // singola delega per dettaglio
    loading: false,      // state per gestire loading
    pratiche: [],
    sediCaf: []
  },
 
  mutations: {
    setInfo(state, value) {
      state.info = value || null
    },
    setDeleghe(state, value) {
      state.deleghe = value || []
    },
    setDelega(state, value) {
      state.delega = value || null
    },
    setLoading(state, value) {
      state.loading = value
    },
    setPratiche(state, pratiche) {
      state.pratiche = pratiche || []
    },
    setSediCaf(state, sedi) {
      state.sediCaf = sedi
    }
  },
 
  actions: {
    async info({ commit }) {
      try {
        let rs = await axios.get('/api/caf/caf')
        commit('setInfo', rs.data)
      } catch (err) {
        throw err
      }
    },

    async loadSedi({ commit }) {
      try {
        const { data } = await axios.get('/api/caf/sedi')
        commit('setSediCaf', data)
        return data
      } catch (err) {
        console.error('Errore caricamento sedi:', err)
        throw err
      }
    },

    // Carica lista deleghe per la sede corrente
    async loadDeleghe({ commit }) {
      try {
        commit('setLoading', true)
        const rs = await axios.get('/api/caf/delegheByCaf')
        commit('setDeleghe', rs.data)
      } catch (err) {
        console.error('Errore caricamento deleghe:', err)
        throw err
      } finally {
        commit('setLoading', false)
      }
    },

    // Carica lista pratiche per la sede corrente 
    async loadPratiche({ commit }) {
      try {
        commit('setLoading', true)
        const rs = await axios.get('/api/caf/praticheByCaf') 
        commit('setPratiche', rs.data)
      } catch (err) {
        console.error('Errore caricamento pratiche:', err)
        throw err
      } finally {
        commit('setLoading', false)
      }
    },

    // Revoca delega
    async revocaDelega({ commit, dispatch }, id) {
      try {
        commit('setLoading', true)
        await axios.post(`/api/caf/deleghe/${id}/revoca`)
        // Ricarica lista dopo revoca
        await dispatch('loadDeleghe')
      } catch (err) {
        console.error('Errore revoca delega:', err)
        throw err
      } finally {
        commit('setLoading', false)
      }
    },

    // chiudi delega
    async chiudiDelega({ commit }, idDelega) {
      try {
        commit('setLoading', true)
        await axios.post(`/api/caf/deleghe/${idDelega}/chiudi`)
      } catch (error) {
        throw error
      } finally {
        commit('setLoading', false)
      }
    },

    // Crea nuova delega
    async addDelega({ commit, dispatch }, payload) {
      try {
        commit('setLoading', true)
        await axios.post('/api/caf/deleghe', payload)
        // Ricarica lista dopo creazione
        await dispatch('loadDeleghe')
      } catch (err) {
        console.error('Errore creazione delega:', err)
        throw err
      } finally {
        commit('setLoading', false)
      }
    },

    // Impersona titolare
    async impersonaTitolare(ctx, { idDelega }) {
      try {
          let rs = await axios.post(`/api/caf/impersonaTitolare`, { idDelega })

          // Aggiorna lo stato dell'utente nello store
          ctx.commit('setUser', rs.data, { root: true })

          return rs.data
      } catch (err) {
          console.error('Errore impersonificazione:', err)
          throw err;
      }
    },
    // Impersona titolare
    async terminaImpersonificazione(ctx, { user }) {
      try {

        let rs = await axios.post(`/api/caf/terminaImpersonificazione`, { user })

        sessionStorage.setItem('cafMode', 'false')

        // Aggiorna direttamente lo stato qui
        ctx.commit('setUser', rs.user, { root: true })

        return rs.data
      } catch (err) {
          console.error('Errore fine impersonificazione:', err)
          throw err;
      } 
    },
    
    async rilasciaDelega({ commit }) {
      try {
        await axios.post('/api/caf/rilasciaDelega')
      } catch (error) {
        console.error('Errore rilascio delega:', error)
      }
    }
  }
 }